import Wrapper from "../../../layout/Wrapper";
import SpecialAgentCommisionComponent from "../../../screens/settings/special-agent-commission";

import MetaComponent from "../../../components/common/MetaComponent";

const metadata = {
	title: "Special Agent Commision",
	description: "",
};

export default function SpecialAgentCommision() {
	return (
		<Wrapper>
			<MetaComponent meta={metadata} />
			<SpecialAgentCommisionComponent />
		</Wrapper>
	);
}